import GetUserProfileUseCase from '../GetUserProfile';
import { IUserSessionRespository } from '@infrastructure/persistance/user-session';
import { HttpPostRequestWithoutToken } from '@infrastructure/axios/http-post-request';
import { BasicAuthenticationUseCase, AuthenticationSession, AccessToken, FiscalIdPasswordAndRecaptcha } from '../../types';

/**
 * ## Login UseCase
 *
 * This represent the authentication of a given user with
 * username and password. Also get the user information and prepare a given response
 * with the entire AuthenticationSession.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class LoginUseCase extends HttpPostRequestWithoutToken<FiscalIdPasswordAndRecaptcha, AccessToken> implements BasicAuthenticationUseCase {
  constructor(private sessionReporsitory: IUserSessionRespository) {
    super();
  }

  public async execute(credentials: FiscalIdPasswordAndRecaptcha): Promise<AuthenticationSession> {
    const loginResponse = await this.dispatch('/auth/login', credentials);
    const authResponse = loginResponse.data.data;
    await this.sessionReporsitory.saveToken(authResponse.token);
    await this.sessionReporsitory.saveRefreshToken(authResponse.refreshToken);

    const user = await new GetUserProfileUseCase(this.sessionReporsitory).execute();

    return { ...user, ...authResponse };
  }
}
